/**
 * Services/Index Controller
 *
 * Displays a list of orders of all services, or a specified service
 */

// the constructor for this object
function TicketsChooseServiceController() { }

// the object
TicketsChooseServiceController.prototype = {
    constructor: TicketsChooseServiceController,

    // this contains the pagination object
    pagination: false,

    // the number of order per page
    perPage: 10,

    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},

    // initialize the controller
    init: function()
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();

        // register the route variables used by this controller
        this._registerRouteVariables();

        // set up the pagination
        this._setupPagination();

        // build the accounts dropdown used in the invoice widget
        this._setupAccountsDropdown();

        PortalHelper.debugMessage('Tickets Choose Service Controller Initialized');
    },

    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();

        // get and populate the orders
        this._getOrders();

        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Tickets Choose Service Controller Ran');
    },

    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#orders-pagination';
        pagination.contentSelector = '#orders-table';
        pagination.searchSelector = '#portal-search';
        pagination.searchColumn = 'search_all';
        pagination.eventCallback = PortalMain.TicketsChooseServiceController._getOrders;
        PortalMain.TicketsChooseServiceController.pagination = pagination;
    },

    // build the accounts dropdown used in the invoice widget
    _setupAccountsDropdown: function()
    {
        // populate the accounts dropdown, and rerun the controller on change
        var ticketsAccountSelector =  new PortalAccountSelector();
        ticketsAccountSelector.setupAccountsDropdown(
            '#account-selection',
            function(currentAccountId) {

                PortalHelper.loadingOverlay('#orders-table', true);
                PortalHelper.loadingOverlay('#orders-pagination', true);

                PortalMain.TicketsChooseServiceController.pagination.setPage(1);

                // get the orders using the new account id
                PortalMain.TicketsChooseServiceController._getOrders();
            }
        );
        this.ticketsAccountSelector = ticketsAccountSelector;
    },

    // get the route variables and include them in the controller
    _registerRouteVariables: function()
    {
        var segments = PortalMain.getRouteSegments();
    },

    // register the javascript events
    _registerEvents:  function()
    {
    },

    // get the orders from the api
    _getOrders: function()
    {
        // get the submission data from the pagination object
        var submissionData = PortalMain.TicketsChooseServiceController.pagination.getBaseSubmissionData();

        // include the account id with the data
        var currentAccountId = PortalMain.PortalAccounts.getCurrentAccountId();
        if (currentAccountId != 0) {
            submissionData.accountId = currentAccountId;
        }

        // make sure the new request isn't the same as the previous one
        if (JSON.stringify(submissionData) == JSON.stringify(PortalMain.TicketsChooseServiceController.lastSubmittedData)) {
            PortalMain.TicketsChooseServiceController.pagination.showPagination();
            return;
        }
        PortalMain.TicketsChooseServiceController.lastSubmittedData = submissionData;

        // make the request
        var ordersRequest = new PortalRequest;
        ordersRequest.pageNumber = submissionData.page;
        ordersRequest.makeRequest(
            '/orders/get-orders',
            submissionData,
            function(data) {

                //handle pagination
                PortalMain.TicketsChooseServiceController.pagination.updatePagination(data);
                PortalMain.TicketsChooseServiceController.pagination.showPagination();

                // fill the invoice chart data
                PortalMain.TicketsChooseServiceController._populateOrdersTable(data);
            }
        );
    },

    // set the headline according to the current product
    _setHeadline: function()
    {
        var headline = 'All Services';

        if (this.productCd !== false) {
            // find the product in question
            var products = PortalMain.PortalProducts.getProducts();
            for (var i in products) {
                var product = products[i];
                if (product.product_cd == this.productCd.toUpperCase()) {
                    if (product.product.toLowerCase().endsWith('services')
                    || product.product.toLowerCase().endsWith('service')) {
                        headline = product.product;
                    } else {
                        headline = product.product + ' Services';
                    }
                }
            }
        }

        $('#headline').html(headline);
    },

    // set the headline according to the current product
    _setBreadcrumbs: function()
    {
        if (this.productCd !== false) {
            var url = '/portal/services';
            var product = PortalMain.PortalProducts.getProduct(this.productCd);
            $('.breadcrumbs a:last-of-type').after('<a href="' + url + '">Services</a>');
            $('.breadcrumbs span').html(product.short_product_name);
        }

        $('.breadcrumbs').removeClass('hidden');
    },

    // some columns aren't need when a product is specified
    _updateDisplayedColumns: function()
    {
        if (this.productCd !== false) {
            $('th[data-sort-column=product]').remove();
            $('td.product').remove();
        }
    },

    // populate the orders table
    _populateOrdersTable: function(ordersData)
    {
        var orders = ordersData.data;

        // clear the old tickets
        $('#orders-table tbody tr:not(.clone-source)').remove();

        // add the new tickets to the DOM
        for (var i in orders) {
            var order = orders[i];
            var newEntry = $('#orders-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');

            // apply the view link
            var chooseLink = PortalConfig.portalUrl;
            chooseLink += '/r/tickets/new-ticket/';
            // chooseLink += '/r/tickets/choose-trouble/'
            chooseLink += order.base_order_id;
            $('.choose-link', newEntry).attr('href', chooseLink);

            // apply the product name (if applicable)
            $('.product', newEntry).html(order.product);

            // apply the order number
            $('.order-number', newEntry).html(order.order_number);

            // apply the uss circuit id
            $('.uss-circuit-id', newEntry).html(order.uss_circuit_id);

            // apply the customer reference
            var reference = order.customer_ref == null ? '' : order.customer_ref;
            $('.customer-reference', newEntry).html(reference);

            // apply the alias
            var alias = order.alias == null ? '' : order.alias;
            $('.alias', newEntry).html(alias);

            // apply the mrc charges
            var dollars = PortalHelper.numberToDollars(order.mrc_charges);
            $('.mrc-charges', newEntry).html(dollars);

            // add to to the table
            $('#orders-table tbody').append(newEntry);
        }

    },
}
